import { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react'

const InboxNotificationContext = createContext(null)

export function InboxNotificationProvider({ children }) {
  const [propertyPanelExpanded, setPropertyPanelExpanded] = useState(false)
  const [notifications, setNotifications] = useState(() => {
    try {
      const raw = localStorage.getItem('inbox_ai_notifications_v1')
      const list = raw ? JSON.parse(raw) : []
      return list.map((n) => ({ ...n, read: n.read ?? false }))
    } catch { return [] }
  })
  const [drawerOpen, setDrawerOpen] = useState(false)
  const selectThreadHandlerRef = useRef(null)

  useEffect(() => {
    try {
      localStorage.setItem('inbox_ai_notifications_v1', JSON.stringify(notifications))
    } catch {}
  }, [notifications])

  const setSelectThreadHandler = (fn) => {
    selectThreadHandlerRef.current = typeof fn === 'function' ? fn : null
  }

  const selectThread = useCallback((threadId, notificationId) => {
    if (notificationId) {
      setNotifications((prev) =>
        prev.map((n) => (n.id === notificationId ? { ...n, read: true } : n))
      )
    }
    selectThreadHandlerRef.current?.(threadId)
  }, [])

  const markAsRead = useCallback((notificationId) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === notificationId ? { ...n, read: true } : n))
    )
  }, [])

  const clearNotifications = useCallback(() => {
    setNotifications([])
  }, [])

  return (
    <InboxNotificationContext.Provider
      value={{
        notifications,
        setNotifications,
        drawerOpen,
        setDrawerOpen,
        propertyPanelExpanded,
        setPropertyPanelExpanded,
        setSelectThreadHandler,
        selectThread,
        markAsRead,
        clearNotifications,
      }}
    >
      {children}
    </InboxNotificationContext.Provider>
  )
}

export function useInboxNotifications() {
  const ctx = useContext(InboxNotificationContext)
  return ctx
}
